'use strict';

module.exports = {
    SIGN: 'تسجيل الدخول',
    SIGN_JOIN: 'اشترك أو انضم مجانًا!',
    EMAIL_EXISTS: 'هذا الحساب موجود بالفعل.',
    INVALID_EMAIL: 'يُرجى إدخال عنوان بريد إلكتروني صالح',
    INVALID_FIRST_NAME: 'الرجاء إدخال اسمًا أول صالحًا',
    INVALID_LAST_NAME: 'الرجاء إدخال اسمًا أخيرًا صالحًا',
    INVALID_PASSWORD: 'الرجاء إدخال من 6 إلى 20 حرف (A-Z, a-z, 0-9 فقط)',
    INVALID_REPASSWORD: 'كلمت المرور غير متطابقتين',
    INVALID_VALID_CODE: 'الرجاء إدخال كودًا صالحًا',
    UNAVIALABLE_SERVICE: 'الخدمة غير متاحة، فيرجى المحاولة مرة أخرى فيما بعد.',
    EMPTY_VALID_CODE: 'أدخل الأحرف التي تراها في الصورة',
    NOT_MEMBER: 'لست عضوًا؟',
    ALREADY_MEMBER: 'هل أنت عضوًا بالفعل في AliExpress/Alibaba؟',
    EMAIL: 'عنوان البريد الإلكتروني',
    CONTACT_NAME: 'اسم جهة الاتصال:',
    FIRST_NAME: ' الاسم الأول',
    LAST_NAME: 'الاسم الأخير',
    PASSWORD: 'كلمة المرور',
    REPASSWORD: 'أعد إدخال كلمة المرور:',
    EMPTY_CODE: 'أدخل الكود الموضح:',
    REFRESH: 'تحديث',
    CREATE_MY_ACCOUNT: 'إنشاء حسابي',
    NAME: 'اسم',
    VERIFICATION: ' رمز التحقق',
    AGREE_MENT: 'عن طريق إنشاء حساب، فإنك توافق على',
    AE_MEMBER_SHIP: 'اتفاقية العضوية المجانية على AliExpress',
    AND: ' و',
    PRIVACY_POLICY: 'سياسة الخصوصية',
    SLIDE_SUBMIT: 'عليك الإزاحة لليمين للتحقق',
    SLIDE_SUBMIT_TIPS: 'نجاح',
    LOADING: 'جاري التحميل...',
    SLIDE_SUBMIT_ERROR_TIPS: 'عليك الإزاحة لليمين للتحقق',
    SHOP_NOW: 'تسوّق الآن',
    SIGN_IN: 'تسجيل الدخول',
    REGISTER_SMS: 'التسجيل باستخدام رسائل SMS',
    REGISTER_EMAIL: 'التسجيل باستخدام البريد الإلكتروني',
    PHONE_NUMBER: 'رقم الهاتف',
    VALID_NUMBER: 'يُرجى إدخال رقم هاتف صالح',
    SEND_SMS_CODE: 'إرسال رمز SMS',
    SMS_POLICY: 'سنرسل رمز التحقق عبر SMS على رقم الهاتف الذي أدخلته. تأكد أن رمز البلد ورقم الهاتف صحيحان.',
    SEND_TO: 'لقد أرسلنا الرمز إلى ',
    VERIFICATION_RECEIVED: 'أدخل رمز التحقق الذي تلقيته أو',
    EDIT_NUMBER: 'عدّل الرقم',
    RESEND_CODE: 'أعد إرسال الرمز',
    LAST_STEP: 'الخطوة الأخيرة',
    SET_SIGN_IN_PASSWORD: 'يُرجى وضع علامة في كلمة المرور لجعل حسابك أكثر أمانًا.',
    INVALID_PHONE_PASSWORD: '6-20 حرفًا (الحروف والأرقام فقط)',
    NOT_CORRECT_CODE: 'الرمز غير صحيح، يُرجى المحاولة مرة أخرى.',
    SAVE_PASSWORD: 'حفظ كلمة المرور',
    NO_RECEIVED_CODE: 'إذا لم تتلقى الرمز بعد، فحاول',
    VIA_EMAIL: 'التسجيل عبر البريد الإلكتروني'
};